module.exports = __webpack_public_path__ + "img/lookbook_12_center_back.2e403d41.png";